import { Box } from "@mui/material";

import { PersonalizeToneOption } from "features/Influencer/QuickSendIndividualDrawer/Dialogs/PersonalizeDialog/schema";

import Chip from "./Chip";
import styles from "./styles";

interface ToneOption {
  id: PersonalizeToneOption;
  label: string;
  emoji: string;
}

interface Props {
  options: ToneOption[];
  value?: PersonalizeToneOption | null;
  onChange: (tone: PersonalizeToneOption) => void;
  grid?: boolean;
}

export default function ToneChips({ options, value, onChange, grid }: Props) {
  return (
    <Box
      sx={
        grid
          ? { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1 }
          : styles.chipRow
      }
    >
      {options.map((option) => (
        <Chip
          key={option.id}
          selected={value === option.id}
          onClick={() => onChange(option.id)}
        >
          <Box component="span" sx={{ fontSize: grid ? 14 : 13 }}>
            {option.emoji}
          </Box>{" "}
          {option.label}
        </Chip>
      ))}
    </Box>
  );
}
